export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';

export const SET_TEXT = 'SET_TEXT';
